const setSelectedCategories = selectedCategories => {
    return {
        type: 'SET_SELECTED_CATEGORIES',
        data: selectedCategories
    }
}

const setOrderType = orderType => {
    return {
        type: 'SET_ORDER_TYPE',
        data: orderType
    }
}

const setCurrentStep = stepNumber => {
    return {
        type: 'SET_CURRENT_STEP',
        data: stepNumber
    }
}

const updateAddressFormField = fieldData => {
    return {
        type: 'UPDATE_ADDRESS_FORM_FIELD',
        data: fieldData
    }
}

const updateAddressData = addressData => {
    return {
        type: 'UPDATE_ADDRESS_DATA',
        data: addressData
    }
}

const resetOrder = () => {
    return {
        type: 'RESET_ORDER'
    }
}

const setCaptcha = captcha => {
    return {
        type: 'SET_CAPTCHA',
        data: captcha
    }
}

const setOrderAttempted = attemptState => {
    return {
        type: 'SET_ORDER_ATTEMPTED',
        data: attemptState
    }
}

const setQuoteRefreshed = createState => {
    return {
        type: 'SET_QUOTE_REFRESHED',
        data: createState
    }
}

const setScheduleDate = date => {
    return {
        type: 'SET_SCHEDULE_DATE',
        data: date
    }
}

const setScheduleShift = shift => {
    return {
        type: 'SET_SCHEDULE_SHIFT',
        data: shift
    }
}

const setScheduleTimeSlot = slot => {
    return {
        type: 'SET_SCHEDULE_TIME_SLOT',
        data: slot
    }
}

const updateMaterialData = data => {
    return {
        type: 'UPDATE_MATERIAL_DATA',
        data: data
    }
}

const setOrderData = data => {
    return {
        type: 'SET_ORDER_DATA',
        data: data
    }
}

const setLeftOverOrder = data => {
    return {
        type: 'SET_LEFT_OVER_ORDER',
        data: data
    }
}

const setTotalConfigs = data => {
    return {
        type: 'SET_TOTAL_CONFIGS',
        data: data
    }
}

const updateConfigData = data => {
    return {
        type: 'UPDATE_CONFIG_DATA',
        data: data
    }
}

const setUseCollectionAddressAsBilling = data => {
    return {
        type: 'SET_USE_COLLECTION_ADDRESS_AS_BILLING',
        data: data
    }
}

const setAddressDataCopy = () => {
    return {
        type: 'SET_ADDRESS_DATA_COPY'
    }
}

const resetOrderData = () => {
    return {
        type: 'RESET_ORDER_DATA'
    }
}

const isGenerateQuoteClicked = (status) => {
    return {
        type: 'IS_GENERATE_QUOTE_CLICKED',
        status
    }
}

const newOrderActions = {
    setSelectedCategories: setSelectedCategories,
    setOrderType: setOrderType,
    setCurrentStep: setCurrentStep,
    updateAddressFormField: updateAddressFormField,
    updateAddressData: updateAddressData,
    setOrderAttempted: setOrderAttempted,
    resetOrder: resetOrder,
    updateMaterialData: updateMaterialData,
    setOrderData: setOrderData,
    setLeftOverOrder: setLeftOverOrder,
    setCaptcha: setCaptcha,
    setScheduleDate: setScheduleDate,
    setScheduleTimeSlot: setScheduleTimeSlot,
    setQuoteRefreshed: setQuoteRefreshed,
    setTotalConfigs: setTotalConfigs,
    updateConfigData: updateConfigData,
    setScheduleShift: setScheduleShift,
    setUseCollectionAddressAsBilling: setUseCollectionAddressAsBilling,
    setAddressDataCopy: setAddressDataCopy,
    resetOrderData: resetOrderData,
    isGenerateQuoteClicked
}

export default newOrderActions;